// src/hooks/useOwlCarousel.js
import { useEffect } from "react";
export const useOwlCarousel = () => {
  useEffect(() => {
    if (!window.$?.fn?.owlCarousel) return;
    window.$(".js-projects-carousel").owlCarousel({
      items: 4,
      margin: 30,
      responsive: {
        0: { items: 1 },
        768: { items: 2 },
        1024: { items: 3 },
        1250: { items: 4 },
      },
      nav: true,
      dots: false,
      slideSpeed: 700,
    });
  }, []);
};
export default useOwlCarousel;
